import { combineReducers } from 'redux';

import popupReducer from './popupReducer';
import projectDataReducer from './projectDataReducer';
import dayReducer from './dayReducer';
import itemsDataReducer from './itemsDataReducer';
import itemsProgressReducer from './itemsProgressReducer';
import selectItemReducer from './selectItemReducer';
import projectUsersReducer from './projectUsersReducer';
import selectedCardsGroupsReducer from './selectedCardsGroupsReducer';
import loadedLevelsReducer from './loadedLevelsReducer';
import responseDataReducer from './responseDataReducer';
import qualityProgressReducer from './qualityProgressReducer';
import popUpMessageReducer from './popUpMessageReducer';
import closedCardsGroupsReducer from './closedCardsGroupsReducer';
import popUpMenuReducer from './popUpMenuReducer';
import deletedCardsGroupsReducer from './deletedCardsGroupsReducer';
import userRoleReducer from './userRoleReducer';
import userDataReducer from './userDataReducer';
import addProgressReducer from './addProgressReducer';
import addPaymentReducer from './addPaymentReducer';
import switchesReducer from './switchesReducer';
import featuresGroupsReducer from './featuresGroupsReducer';
import generateCycleReducer from './generateCycleReducer';
import loadingLevelIdReducer from './loadingLevelIdReducer';
import matchesReducer from './matchesReducer';
import signaturesUserReducer from './signaturesUserReducer';
import visibleCardsGroupIdsReducer from './visibleCardsGroupIdsReducer';
import standByCardsGroupsReducer from './standByCardsGroupsReducer';
import paintReducer from './paintReducer';
import filtersReducer from './filtersReducer';
import opacityReducer from './opacityReducer';
import activeTabReducer from './setActiveTabReducer';
import signaturesFilterHistoricReducer from './signaturesFilterHistoricReducer';
import signaturesFilterChange from './signaturesFilterReducer';
import cardsGroupsWithHistoricalObservationsReducer from './cardsGroupWithHistoricalObservations';
import breakCoordinatesModalReducer from './breakCoordinatesModalReducer';
import customcardTypesReducer from './customcardTypesReducer';


const allReducers = combineReducers({
    day                 : dayReducer,
    popup               : popupReducer,
    projectData         : projectDataReducer,
    switches            : switchesReducer,
    filters             : filtersReducer,
    itemsData           : itemsDataReducer,
	itemsProgress       : itemsProgressReducer,
    qualityProgress     : qualityProgressReducer,
    paint               : paintReducer,
    opacity             : opacityReducer,
	selectedItem        : selectItemReducer,
    signaturesUserId    : signaturesUserReducer,
    projectUsers        : projectUsersReducer,
    selectedCardsGroups : selectedCardsGroupsReducer,
    loadedLevels        : loadedLevelsReducer,
    loadingLevelId      : loadingLevelIdReducer,
    responseData        : responseDataReducer,
    popUpMenu           : popUpMenuReducer,
    popUpMessage        : popUpMessageReducer,
    closedCardsGroups   : closedCardsGroupsReducer,
    standByCardsGroups  : standByCardsGroupsReducer,
    deletedCardsGroups  : deletedCardsGroupsReducer,
    visibleCardsGroupIds: visibleCardsGroupIdsReducer,
    userRole            : userRoleReducer,
    userData            : userDataReducer,
    addProgress         : addProgressReducer,
    addPayment          : addPaymentReducer,
    featuresGroups      : featuresGroupsReducer,
    generateCycle       : generateCycleReducer,
    matches             : matchesReducer,
    activeTab           : activeTabReducer,
    signaturesFilterHistoric    : signaturesFilterHistoricReducer,
    signaturesFilter :   signaturesFilterChange,
    cardsGroupsWithHistoricalObservations : cardsGroupsWithHistoricalObservationsReducer,
    breakCoordinatesModal : breakCoordinatesModalReducer,
    customcardTypes : customcardTypesReducer,
})

export default allReducers;